<template>
  <div>
    <div class="parentInput" v-cloak>
        <input id="inputID" v-show="false" type="file" class="input"/>
        <label for="inputID">
        <v-icon class="mr-1" color="neutralGray1">mdi-attachment</v-icon>
        {{ $t("agenda.AttachFile") }}
        </label>
    </div>
  </div>
</template>

<script>
export default {
    name: "FileInput"
}
</script>

<style scoped>
.parentInput {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 8px;
  border: dashed 1px var(--v-neutralGray1-base);
  border-radius: 4px;
}
::v-deep .input + label {  
  color: var(--v-neutralGray1-base);
  min-width: 100%;
  font-family: 'Noto Sans JP';
  font-weight: 400;
  font-size: 12px;
}
::v-deep .input:focus + label, .input + label:hover {
  cursor: pointer;
}
</style>